import { useMutation, useQueryClient } from "react-query";
import { shop } from "@/repositories/shop";
import { Integrators } from "@/types/v2";
import { useInvalidateTotalShopsQuery } from "@/hooks/queries/useTotalShopsQuery";

export const useAdminCreateShopMutation = () => {
  const queryClient = useQueryClient();
  const invalidateTotalShops = useInvalidateTotalShopsQuery();

  return useMutation(
    (data: {
      email: string;
      shopName: string;
      integrator?: Integrators;
      sendActivationEmailNow: boolean;
      loginLink: string;
    }) => shop.adminCreateShop(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["paginated-shops"]);
        invalidateTotalShops();
      },
    }
  );
};
